import { Box, Divider, Skeleton } from '@hopskipdrive/react-components';

import { OTHER } from '../../../../constants/locationTypes';
import { PageHeading } from '../../../../shared/components/PageHeading';
import { colorTokens } from '../../../../shared/components/variables';
import { MustBeMetProtocolSkeleton } from '../../MustBeMetProtocolForm/MustBeMetProtocolSkeleton';
import { RiderLocation } from '../Location/Location.types';

import { PrimaryContainer } from './RiderLocationForm.styles';

export const RiderLocationFormSkeleton = ({ location }: { location: RiderLocation }) => (
  <Box>
    <Box mb="1rem">
      <Divider mt="24px" mb="12px" />
      <PageHeading variant="h2" sx={{ margin: '16px 0px', color: `${colorTokens.primary.main} !important` }}>
        Instructions for this rider
      </PageHeading>
    </Box>
    {location.locationType && location.locationType !== OTHER && (
      <PrimaryContainer>
        <Skeleton width={350} height={38} />
      </PrimaryContainer>
    )}
    <PrimaryContainer>
      <Skeleton width={300} height={38} />
    </PrimaryContainer>
    {location.mustBeMet && <MustBeMetProtocolSkeleton groupCount={location.authorizedContactGroups?.length} />}
    <Box my={4}>
      <Skeleton width={180} height={20} />
    </Box>
    <Skeleton width={340} height={38} />
  </Box>
);
